(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["apet-calendrier"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const bouton = e.target.closest('.apet-cal__case');
    if (!bouton) return;
    const cal = bouton.closest('[data-apet-cal]');
    const detail = cal.querySelector('.apet-cal__detail');
    const jour = bouton.dataset.jour;
    cal.querySelectorAll('.apet-cal__case.is-active').forEach((c) => c.classList.remove('is-active'));

    if (bouton.dataset.panneau) {
      const modele = document.getElementById(bouton.dataset.panneau);
      bouton.classList.add('is-open', 'is-active');
      bouton.setAttribute('aria-expanded', 'true');
      bouton.setAttribute('aria-label', 'Case ' + jour + ' : ouverte');
      detail.replaceChildren(modele.content.cloneNode(true));
    } else {
      bouton.classList.remove('is-nope');
      void bouton.offsetWidth;
      bouton.classList.add('is-nope');
      const p = document.createElement('p');
      p.className = 'apet-cal__legende';
      p.textContent = (cal.dataset.messageFerme || '').replace('[jour]', jour);
      detail.replaceChildren(p);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
